import React, { ComponentProps, FC } from 'react';

import { AudioSettingPopupButtonContainer } from '../../skin/audio-setting-popup-button/container';

import { useSelectTrack } from './hooks/use-select-track';

type Props = Omit<
    ComponentProps<typeof AudioSettingPopupButtonContainer>,
    'onSelectAudioTrack' | 'onSelectTextTrack' | 'withAudioTracksIntersection'
>;

export const MovieAudioSettingPopupButtonContainer: FC<Props> = ({ contentId, ...props }) => {
    const { onAudioLangChange, onSubtitlesLangChange } = useSelectTrack(contentId);

    return (
        <AudioSettingPopupButtonContainer
            contentId={contentId}
            onSelectAudioTrack={onAudioLangChange}
            onSelectTextTrack={onSubtitlesLangChange}
            {...props}
        />
    );
};
